import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"
import { useCloudProviderContext } from "../hooks/useCloudProviderContext"
import CloudBrowserContent from "./CloudBrowserContent"
import CloudBrowserImportOverlay from "./CloudBrowserImportOverlay"
import CloudBrowserSidebar from "./CloudBrowserSidebar"

interface Props {
  isOpen: boolean
  onClose: () => void
}

const CloudBrowserModalDesktop: React.FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation()
  const { isImportingImages } = useCloudProviderContext()

  return (
    <Modal
      isOpen={isOpen}
      size="5xl"
      onClose={onClose}
      returnFocusOnClose={false}
      closeOnOverlayClick={!isImportingImages}
      closeOnEsc={!isImportingImages}
    >
      <ModalOverlay />
      <ModalContent position="relative" overflow="hidden">
        <ModalHeader borderBottomWidth={1}>
          {t(
            "components.cloudProvider.common.CloudBrowserModalDesktop.ImportPhotos"
          )}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody px={0} pt={0}>
          <Flex flexDirection="row" minH="500px">
            <Box minWidth="240px">
              <CloudBrowserSidebar />
            </Box>
            <CloudBrowserContent isMobile={false} />
          </Flex>
        </ModalBody>
        {isImportingImages && <CloudBrowserImportOverlay />}
      </ModalContent>
    </Modal>
  )
}

export default CloudBrowserModalDesktop
